const ApiURL = "https://strapi.codesour.dev";
export default ApiURL;
